import React from 'react';
import ReactDOM from 'react-dom';
import Home from './home';
import Products from './components/tabs';
import AboutUs from './components/aboutus';
import Contact from './components/contact';
import CompanyProfile from './components/dashboard';
import Order from './components/giveorder';
import Profile from './pages/profile';
import Orders from './components/orders'
import './assets/custom.css';
import {HashRouter, Route} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';

import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
    <MuiThemeProvider>
        <HashRouter basename={'/'}>
            <div>
                <Route exact path ={`${process.env.PUBLIC_URL}/`} component={Home}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/profil`} component={Profile}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/saydamprofil`} component={CompanyProfile}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/urunlerimiz`} component={Products}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/siparis-ver`} component={Order}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/siparislerim`} component={Orders}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/hakkimizda`} component={AboutUs}></Route>
                <Route exact path = {`${process.env.PUBLIC_URL}/iletisim`} component={Contact}></Route>
            </div>
        </HashRouter>
    </MuiThemeProvider>
    , document.getElementById('root')
);
registerServiceWorker();